<div class="route-component">
    <div class="search-component">
        <h4>
            Saved POPI Mappings
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button (click)="createMapping()">
                        Add POPI Mappings
                    </button>
                    <button class="back-button" (click)="goBack()">
                        Back To Search
                   </button>
                </div>
            </div>
        </div>

        <div class="loader-wrapper" *ngIf="isLoading">
            <div class="bar-loader"></div>
            <span class="loading-text">Loading...</span>
        </div>

        <div class="data-preview-container" *ngIf="!isLoading && mappings.length > 0">
            <table table class="data-preview-table">
                <thead>
                    <tr>
                        <th>Display Name</th>
                        <th>Database</th>
                        <th>Table</th>
                        <th>Fields</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let m of mappings">
                        <td>{{ m.displayName }}</td>
                        <td>{{ m.dbName }}</td>
                        <td>{{ m.tableName }}</td>
                        <td>{{ m.fields?.length || 0 }}</td>
                        <td>
                            <button *ngIf="m.isValidMapping !== false" (click)="goToEdit(m)">Edit</button>
                            <button *ngIf="m.isValidMapping === false" (click)="deleteMapping(m)">Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="!isLoading && mappings.length === 0" class="no-data">
            No mappings found.
        </div>
    </div>
</div>